<template>
  <div class="home">
    <div class="homep">
      <Tabs value="name1" class="bodys">
        <TabPane label="基本信息" name="name1">
          <div class="center">
            <Form :model="formItem" :label-width="100">
              <FormItem label="头像">
                <img src="static/img/6.jpg" class="img-avatar" alt="o">
              </FormItem>
              <FormItem label="账号名">
                <Row>
                  <Col span="24">
                  <Input v-model="formItem.name" disabled></Input>
                  </Col>
                </Row>
              </FormItem>
              <FormItem label="性别">
                <RadioGroup v-model="formItem.radio">
                  <Radio label="male">男</Radio>
                  <Radio label="female">女</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="修改密码">
                <Row>
                  <Col span="24">
                  <Input ref='input1' v-model="formItem.password" v-if="disabled" placeholder="*****"></Input>
                  <Input ref='input2' v-model="formItem.password" v-if="disabled2" disabled placeholder="*****"></Input>
                  </Col>
                </Row>
              </FormItem>
              <FormItem label="电话号码">
                <Row>
                  <Col span="24">
                  <Input v-model="formItem.tel" disabled>></Input>
                  </Col>
                </Row>
              </FormItem>
              <FormItem label="邮箱">
                <Row>
                  <Col span="24">
                  <Input v-model="formItem.email" disabled></Input>
                  </Col>
                </Row>
              </FormItem>
              <FormItem>
                <Row>
                  <Col span="6" offset="6">
                  <Button type="primary" @click="submitpassword">提交</Button>
                  </Col>
                  <Col span="12">
                  <Button type="info" @click="modifypassword">修改</Button>
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </div>
        </TabPane>
      </Tabs>
    </div>

  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      disabled: false,
      disabled2: true,
      formItem: {
        name: "",
        password: "",
        tel: "",
        email: "",
        radio: "male",
        id: ""
      }
    };
  },
  methods: {
    modifypassword() {
      this.disabled = true;
      this.disabled2 = false;
    },
    submitpassword() {
      let data = {
        id: this.formItem.id,
        params: {
          password: this.formItem.password,
          tel: this.formItem.tel,
          email: this.formItem.email
        }
      };
      this.$store.dispatch("Modifyuser", data).then(res => {
        console.log(res.code);
        if (res.data.code == 200) {
          this.$Notice.success({
            title: "修改成功",
            desc: res.data.message
          });
          this.disabled = false;
          this.disabled2 = true;
        }
      });
    },
    getInfo() {
      this.$store.dispatch("GetInfo").then(res => {
        this.formItem.tel = res.data.tel;
        this.formItem.email = res.data.email;
        this.formItem.name = res.data.name;
        this.formItem.id = res.data.id;
      });
    }
  }
};
</script>
<style scoped lang="scss">
.home {
  .homep {
    margin:0% 5% 0 5% ;
    padding:5% 0% 19% 5%;
    background:#fff;
    .center {
      padding-top:5%;
      width:40%;
      text-align:center;
      margin:0 auto;
    }
  }
}
</style>
